import React, { Component, Fragment } from 'react';
import { Route } from 'react-router-dom';

// Home
import Dashboard from '../pages/home/Dashboard';

// Dosen
import Dosen from '../pages/dosen/dataDosen/DataDosen';
import Perwalian from '../pages/dosen/perwalian/Perwalian';

// Mahasiswa
import DataMahasiswa from '../pages/mahasiswa/dataMahasiswa/DataMahasiswa';
import GeneratePass from '../pages/mahasiswa/generatePass/GeneratePass';
import StatusMahasiswa from '../pages/mahasiswa/statusMahasiswa/StatusMahasiswa';
import CekKrsMahasiswa from '../pages/mahasiswa/cekKrsMahasiswa/CekKrsMahasiswa';
import MahasiswaKartu from '../pages/mahasiswa/cetakMahasiswaKartu/MahasiswaKartu';
import HistoryMahasiswa from '../pages/mahasiswa/historyMahasiswa/HistoryMahasiswa';
import DetailSemester from '../pages/mahasiswa/historyMahasiswa/DetailSemester';

// Mahasiswa Detail
import Biodata from '../pages/mahasiswa/dataMahasiswa/detail/Biodata';
import PengajuanKrs from '../pages/mahasiswa/dataMahasiswa/detail/PengajuanKrs';
import JadwalMhs from '../pages/mahasiswa/dataMahasiswa/detail/JadwalMhs';
import Khs from '../pages/mahasiswa/dataMahasiswa/detail/KHS';
import Krs from '../pages/mahasiswa/dataMahasiswa/detail/KRS';
import Transkrip from '../pages/mahasiswa/dataMahasiswa/detail/Transkrip';
import HistoryBatal from '../pages/mahasiswa/dataMahasiswa/detail/HistoryBatal';
import Presensi from '../pages/mahasiswa/dataMahasiswa/detail/Presensi';
import StatusMhs from '../pages/mahasiswa/dataMahasiswa/detail/StatusMhs';

// Print
import PrintTranskripSementara from '../pages/mahasiswa/dataMahasiswa/detail/printTranskrip/PrintTranskripSementara';
import PrintTranskripSementaraEnglish from '../pages/mahasiswa/dataMahasiswa/detail/printTranskrip/PrintTranskripSementaraEnglish';
import PrintTranskrip from '../pages/mahasiswa/dataMahasiswa/detail/printTranskrip/printTranskrip';
import PrintBio from '../pages/mahasiswa/dataMahasiswa/detail/bioAsset/PrintBio';

class AdminRoutes extends Component {
    render() {
        return (
            <Fragment>
                {/* Home */}
                <Route path="/home" component={Dashboard} />

                {/* Dosen */}
                <Route path="/data-dosen">
                    <Dosen grub_id={this.props.grub_id} />
                </Route>
                <Route path="/perwalian" component={Perwalian} />

                {/* Mahasiswa - Main */}
                <Route exact path="/data-mahasiswa">
                    <DataMahasiswa grub_id={this.props.grub_id} />
                </Route>
                <Route path="/generate-pw" component={GeneratePass} />
                <Route path="/status-mhs">
                    <StatusMahasiswa grub_id={this.props.grub_id} />
                </Route>
                <Route path="/cek-krs">
                    <CekKrsMahasiswa grub_id={this.props.grub_id} />
                </Route>
                <Route path="/mahasiswa-kartu" component={MahasiswaKartu} />
                <Route path="/history-mhs" component={HistoryMahasiswa} />
                <Route path="/detailsemester" component={DetailSemester} />

                {/* Mahasiswa - Detail */}
                <Route path="/data-mahasiswa/biodata" component={Biodata} />
                <Route path="/data-mahasiswa/pengajuanKrs/:idMhs" component={PengajuanKrs} />
                <Route path="/data-mahasiswa/jadwal" component={JadwalMhs} />
                <Route exact path="/data-mahasiswa/khs">
                    <Khs grub_id={this.props.grub_id} />
                </Route>
                <Route path="/data-mahasiswa/krs" component={Krs} />
                <Route path="/data-mahasiswa/transkrip" component={Transkrip} />
                <Route path="/data-mahasiswa/presensi" component={Presensi} />
                <Route path="/data-mahasiswa/historybatal" component={HistoryBatal} />
                <Route path="/data-mahasiswa/status-mhs" component={StatusMhs} />

                {/* Print */}
                <Route path="/printtranskripsementara" component={PrintTranskripSementara} />
                <Route path="/printtranskripsementara-english" component={PrintTranskripSementaraEnglish} />
                <Route path="/printtranskrip" component={PrintTranskrip} />
                <Route path="/printBiodata" component={PrintBio} />
            </Fragment>
        );
    }
}

export default AdminRoutes;
